// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2U80V","image":"Card_image__VZTa-","info":"Card_info__2y6Wt","name":"Card_name__1TS-2","tagline":"Card_tagline__4xT2q","abv":"Card_abv__276z2"};